import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { ButtonInput } from "../Inputs/ButtonInput";


interface WarningBarProps {
  children: any;
  button?: any;
}

export default function WarningBar({ children, button }: WarningBarProps) {

  return (
    <div className="flex flex-row items-center justify-between mt-4 px-4 py-2 bg-red-100 text-red-600 rounded-md shadow">
      <div className="flex flex-row items-center space-x-6">
        <ExclamationCircleIcon className="ml-2 w-16 h-16" />
        {children}
      </div>
      {button}
    </div>
  )
}